import { render, staticRenderFns } from "./client-connections.component.vue?vue&type=template&id=900bdb14&scoped=true&"
import script from "./client-connections.component.vue?vue&type=script&lang=js&"
export * from "./client-connections.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900bdb14",
  null
  
)

export default component.exports